import { ReactNode } from "react";

/** Inline form field label with optional required asterisk / optional hint. */
export const FieldLabel = ({
  children,
  required,
  optionalHint,
  htmlFor,
}: {
  children: ReactNode;
  required?: boolean;
  optionalHint?: string;
  htmlFor?: string;
}) => (
  <label htmlFor={htmlFor} className="label">
    {children}
    {required && <span className="text-required-star ml-0.5">*</span>}
    {optionalHint && <span className="font-normal text-accent-250 ml-1">({optionalHint})</span>}
  </label>
);
